import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { CreateOrUpdateIcon, Icon } from '@thro-types/users';

import { AxiosRequestConfig } from 'axios';
import { useState } from 'react';

import { getIcons, createIcon } from 'api/usersService';

/**
 * A custom hook to create an icon
 *
 * @returns UseMutationResult<Icom, Error>
 */
export const useIconsMutation = (config?: AxiosRequestConfig) => {
  const queryClient = useQueryClient();

  const create = useMutation<Icon, Error, CreateOrUpdateIcon>({
    mutationFn: args => {
      return createIcon(args, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: ['icons'] });
    }
  });
  return { create } as const;
};

/**
 * A custom hook for all icons related things from the UsersService.
 *
 * @returns DefinedUseQueryResult<Tile[], Error>
 */
export const useIconsQuery = (config?: AxiosRequestConfig) => {
  const queryClient = useQueryClient();
  const [enableQuery, setEnableQuery] = useState(true);

  const queryKey = ['icons', config ? JSON.stringify(config.params) : ''];

  // const update = useMutation<Icon, Error, { id: number; data: CreateOrUpdateIcon }>({
  //   mutationFn: args => {
  //     setEnableQuery(false);
  //     return updateTile(args.id, args.data, config);
  //   },
  //   onSuccess: data => {
  //     setEnableQuery(true);
  //     queryClient.invalidateQueries({ queryKey });
  //   },
  //   onError: data => {
  //     setEnableQuery(true);
  //   }
  // });

  // const deletion = useMutation<Icon, Error, number>({
  //   mutationFn: args => {
  //     setEnableQuery(false);
  //     return deleteTile(args, config);
  //   },
  //   onSuccess: data => {
  //     setEnableQuery(true);
  //     queryClient.invalidateQueries({ queryKey });
  //   },
  //   onError: data => {
  //     setEnableQuery(true);
  //   }
  // });

  const query = useQuery({
    queryKey,
    enabled: enableQuery,
    queryFn: () => {
      const icons = getIcons(config);
      return icons;
    },
    initialData: []
  });

  return { query } as const;
};
